import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppliedPayment } from '../../../shared/entities/AppliedPayment';
import { QuickSearchResults } from '../../../shared/entities/QuickSearchResults';

@Injectable()
export class QuicksearchService {
  quicksearchResults: QuickSearchResults[];
  appliedPayments: AppliedPayment[];
  qsrCurrentGridView: number = 0;
  autoHide: boolean = true;

  updateInvoiceDetail(invoiceDetail: QuickSearchResults): void {
    let ii: number;

    for (ii = 0; ii < this.quicksearchResults.length; ii++) {
      if (invoiceDetail.invoiceNumber === this.quicksearchResults[ii].invoiceNumber) {
        this.quicksearchResults[ii] = invoiceDetail;
      }
    }
  }

  resetClearDataStructures(): void {
    this.quicksearchResults = [];
    this.appliedPayments = [];
    this.qsrCurrentGridView = 0;
    this.autoHide = true;
  }

  setQuickSearchCriteriaAutoHide(autoHideStatus: boolean): void {
    this.autoHide = autoHideStatus;
  }

  getQuickSearchCriteriaAutoHide(): boolean {
    return this.autoHide;
  }

  setQuickSearchResults(quicksearchResults: QuickSearchResults[]): void {
    this.quicksearchResults = quicksearchResults;
  }

  getQuickSearchResults(): QuickSearchResults[] {
    return this.quicksearchResults;
  }

  setAppliedPayments(payments: AppliedPayment[]): void {
    this.appliedPayments = payments;
  }

  getAppliedPayments(): AppliedPayment[] {
    return this.appliedPayments;
  }

  setCurrentQSRGridView(gridViewValue: number): void {
    this.qsrCurrentGridView = gridViewValue;
  }

  getCurrentQSRGridView(): number {
    return this.qsrCurrentGridView;
  }

  synchInvoiceToCachedData(invoiceData: QuickSearchResults): void {
    let ii: number = 0;
    for (ii = 0; ii < this.quicksearchResults.length; ii++) {
      if (invoiceData.invoiceNumber === this.quicksearchResults[ii].invoiceNumber) {
        this.quicksearchResults[ii] = invoiceData;
        break;
      }
    }
  }
}
